import AppComponentKey from '@/models/app-component-key';

export default class WebPartItem {
    constructor(data) {
        Object.assign(this, data);

        this.componentName = getComponentName(this.appComponentKey);
    }
}

function getComponentName(appComponentKey) {
    switch (appComponentKey) {
        case AppComponentKey.Grid:
            return 'webpart-list';
        case AppComponentKey.Tree:
            return 'tree-data';
        case AppComponentKey.WebSite:
            return 'web-site';
        case AppComponentKey.TreeMenu:
            return 'webpart-tree-menu';

        default:
            return null;
    }
}
